"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AAS Indexer API
 * The API implemented by the AAS indexer
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AASCacheApi = exports.AASCacheApiFactory = exports.AASCacheApiFp = exports.AASCacheApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AASCacheApi - axios parameter creator
 * @export
 */
const AASCacheApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Asset with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCachedAasdescriptorByAssetIdentifier: async (identifier, options = {}) => {
            // verify required parameter 'identifier' is not null or undefined
            common_1.assertParamExists('findCachedAasdescriptorByAssetIdentifier', 'identifier', identifier);
            const localVarPath = `/cache/aas/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Submodel with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCachedAasdescriptorBySubmodelIdentifier: async (identifier, options = {}) => {
            // verify required parameter 'identifier' is not null or undefined
            common_1.assertParamExists('findCachedAasdescriptorBySubmodelIdentifier', 'identifier', identifier);
            const localVarPath = `/cache/aas/submodel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request the AAS definition with the given aas ID for the server with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasByHash: async (hash, options = {}) => {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getCachedAasByHash', 'hash', hash);
            const localVarPath = `/cache/aas/{hash}`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all descriptors of cached AASs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasDescriptors: async (options = {}) => {
            const localVarPath = `/cache/descriptors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the descriptors of cached AASs matching the supplied selector/filter
         * @param {AASSelector} aASSelector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasDescriptorsFiltered: async (aASSelector, options = {}) => {
            // verify required parameter 'aASSelector' is not null or undefined
            common_1.assertParamExists('getCachedAasDescriptorsFiltered', 'aASSelector', aASSelector);
            const localVarPath = `/cache/descriptors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(aASSelector, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the Asset for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAsset: async (hash, options = {}) => {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getCachedAsset', 'hash', hash);
            const localVarPath = `/cache/aas/{hash}/asset`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a submodel with the given short id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelByShortId: async (hash, idShort, options = {}) => {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelByShortId', 'hash', hash);
            // verify required parameter 'idShort' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelByShortId', 'idShort', idShort);
            const localVarPath = `/cache/aas/{hash}/submodels/{idShort}`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)))
                .replace(`{${"idShort"}}`, encodeURIComponent(String(idShort)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a submodel element on a given path for a submodel with the given id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {string} sepath
         * @param {'JSON' | 'FILE' | 'BLOB'} [returnType] Request a specific return type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelElementBySepath: async (hash, idShort, sepath, returnType, options = {}) => {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelElementBySepath', 'hash', hash);
            // verify required parameter 'idShort' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelElementBySepath', 'idShort', idShort);
            // verify required parameter 'sepath' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelElementBySepath', 'sepath', sepath);
            const localVarPath = `/cache/aas/{hash}/submodels/{idShort}/{sepath}`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)))
                .replace(`{${"idShort"}}`, encodeURIComponent(String(idShort)))
                .replace(`{${"sepath"}}`, encodeURIComponent(String(sepath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (returnType !== undefined) {
                localVarQueryParameter['returnType'] = returnType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request all submodels for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelsByAasHash: async (hash, options = {}) => {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getCachedSubmodelsByAasHash', 'hash', hash);
            const localVarPath = `/cache/aas/{hash}/submodels`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReferences: async (reference, options = {}) => {
            // verify required parameter 'reference' is not null or undefined
            common_1.assertParamExists('resolveReferences', 'reference', reference);
            const localVarPath = `/cache/reference/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reference, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AASCacheApiAxiosParamCreator = AASCacheApiAxiosParamCreator;
/**
 * AASCacheApi - functional programming interface
 * @export
 */
const AASCacheApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AASCacheApiAxiosParamCreator(configuration);
    return {
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Asset with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCachedAasdescriptorByAssetIdentifier(identifier, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCachedAasdescriptorByAssetIdentifier(identifier, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Submodel with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCachedAasdescriptorBySubmodelIdentifier(identifier, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCachedAasdescriptorBySubmodelIdentifier(identifier, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Request the AAS definition with the given aas ID for the server with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedAasByHash(hash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedAasByHash(hash, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns all descriptors of cached AASs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedAasDescriptors(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedAasDescriptors(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns the descriptors of cached AASs matching the supplied selector/filter
         * @param {AASSelector} aASSelector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedAasDescriptorsFiltered(aASSelector, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedAasDescriptorsFiltered(aASSelector, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get the Asset for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedAsset(hash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedAsset(hash, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Request a submodel with the given short id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedSubmodelByShortId(hash, idShort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedSubmodelByShortId(hash, idShort, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Request a submodel element on a given path for a submodel with the given id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {string} sepath
         * @param {'JSON' | 'FILE' | 'BLOB'} [returnType] Request a specific return type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Request all submodels for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCachedSubmodelsByAasHash(hash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCachedSubmodelsByAasHash(hash, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveReferences(reference, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveReferences(reference, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AASCacheApiFp = AASCacheApiFp;
/**
 * AASCacheApi - factory interface
 * @export
 */
const AASCacheApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AASCacheApiFp(configuration);
    return {
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Asset with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCachedAasdescriptorByAssetIdentifier(identifier, options) {
            return localVarFp.findCachedAasdescriptorByAssetIdentifier(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds the AAS (i.e. AASDescriptor) containing the Submodel with matching identifier
         * @param {Identifier} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCachedAasdescriptorBySubmodelIdentifier(identifier, options) {
            return localVarFp.findCachedAasdescriptorBySubmodelIdentifier(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Request the AAS definition with the given aas ID for the server with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasByHash(hash, options) {
            return localVarFp.getCachedAasByHash(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all descriptors of cached AASs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasDescriptors(options) {
            return localVarFp.getCachedAasDescriptors(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the descriptors of cached AASs matching the supplied selector/filter
         * @param {AASSelector} aASSelector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAasDescriptorsFiltered(aASSelector, options) {
            return localVarFp.getCachedAasDescriptorsFiltered(aASSelector, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the Asset for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedAsset(hash, options) {
            return localVarFp.getCachedAsset(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a submodel with the given short id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelByShortId(hash, idShort, options) {
            return localVarFp.getCachedSubmodelByShortId(hash, idShort, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a submodel element on a given path for a submodel with the given id
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {string} idShort A short id
         * @param {string} sepath
         * @param {'JSON' | 'FILE' | 'BLOB'} [returnType] Request a specific return type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options) {
            return localVarFp.getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options).then((request) => request(axios, basePath));
        },
        /**
         * Request all submodels for the AAS with the given hash
         * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCachedSubmodelsByAasHash(hash, options) {
            return localVarFp.getCachedSubmodelsByAasHash(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReferences(reference, options) {
            return localVarFp.resolveReferences(reference, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AASCacheApiFactory = AASCacheApiFactory;
/**
 * AASCacheApi - object-oriented interface
 * @export
 * @class AASCacheApi
 * @extends {BaseAPI}
 */
class AASCacheApi extends base_1.BaseAPI {
    /**
     * Finds the AAS (i.e. AASDescriptor) containing the Asset with matching identifier
     * @param {Identifier} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    findCachedAasdescriptorByAssetIdentifier(identifier, options) {
        return exports.AASCacheApiFp(this.configuration).findCachedAasdescriptorByAssetIdentifier(identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds the AAS (i.e. AASDescriptor) containing the Submodel with matching identifier
     * @param {Identifier} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    findCachedAasdescriptorBySubmodelIdentifier(identifier, options) {
        return exports.AASCacheApiFp(this.configuration).findCachedAasdescriptorBySubmodelIdentifier(identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request the AAS definition with the given aas ID for the server with the given hash
     * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedAasByHash(hash, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedAasByHash(hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all descriptors of cached AASs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedAasDescriptors(options) {
        return exports.AASCacheApiFp(this.configuration).getCachedAasDescriptors(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the descriptors of cached AASs matching the supplied selector/filter
     * @param {AASSelector} aASSelector
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedAasDescriptorsFiltered(aASSelector, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedAasDescriptorsFiltered(aASSelector, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the Asset for the AAS with the given hash
     * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedAsset(hash, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedAsset(hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request a submodel with the given short id
     * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
     * @param {string} idShort A short id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedSubmodelByShortId(hash, idShort, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedSubmodelByShortId(hash, idShort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request a submodel element on a given path for a submodel with the given id
     * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
     * @param {string} idShort A short id
     * @param {string} sepath
     * @param {'JSON' | 'FILE' | 'BLOB'} [returnType] Request a specific return type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedSubmodelElementBySepath(hash, idShort, sepath, returnType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request all submodels for the AAS with the given hash
     * @param {string} hash A hash which uniquely identifies an AAS on an AASX server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    getCachedSubmodelsByAasHash(hash, options) {
        return exports.AASCacheApiFp(this.configuration).getCachedSubmodelsByAasHash(hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
     * @param {Array<Reference>} reference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AASCacheApi
     */
    resolveReferences(reference, options) {
        return exports.AASCacheApiFp(this.configuration).resolveReferences(reference, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AASCacheApi = AASCacheApi;
//# sourceMappingURL=aascache-api.js.map